/* eslint-disable */
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import UserJobPost from 'types/jobPosts';

interface UseGetUserJobPosts {
  allJobPosts: UserJobPost[];
  hasJobPosts: boolean;
  userJobPosts: UserJobPost[];
  savedJobPosts: UserJobPost[];
  jobPostsWithCandidates: UserJobPost[];
}

const getSavedJobPosts = createSelector(
  (state: any) => state.jobPosts.userJobPosts,
  userJobPosts => {
    return (
      userJobPosts.length &&
      userJobPosts.filter((jobPost: any) => jobPost.saved && !jobPost.candidateCount)
    );
  }
);

const getJobPostsWithCandidates = createSelector(
  (state: any) => state.jobPosts.userJobPosts,
  userJobPosts => {
    return (
      userJobPosts.length && userJobPosts.filter((jobPost: any) => jobPost.candidateCount > 0)
    );
  }
);

const useGetJobPosts = (): UseGetUserJobPosts => {
  const allJobPosts = useSelector<any, UserJobPost[]>(state => state.jobPosts.allJobPosts);

  const userJobPosts = useSelector<any, UserJobPost[]>(state => state.jobPosts.userJobPosts);

  const savedJobPosts = useSelector<any, UserJobPost[]>(getSavedJobPosts);

  const jobPostsWithCandidates = useSelector<any, UserJobPost[]>(getJobPostsWithCandidates);

  const hasJobPosts = !!allJobPosts.length || !!userJobPosts.length;

  return {
    allJobPosts,
    userJobPosts,
    hasJobPosts,
    savedJobPosts,
    jobPostsWithCandidates,
  };
};

export default useGetJobPosts;
